import { defineAction } from '~/prix'
import materialDeliveryFetchAction from './materialDeliveryFetch.action.json' with { type: 'json' }
import { materialDeliveryObject } from '../materialDeliveryObject'

const materialDeliveryFetchDefinition = defineAction({
  ...materialDeliveryFetchAction,
  input: materialDeliveryObject.pick({ id: true }),
  output: materialDeliveryObject,
})

export default materialDeliveryFetchDefinition
